export default "__VITE_ASSET__BuhJBRhf__"